module.exports = __webpack_public_path__ + "d8373b61fe16396b84210c0fc97e4b8a.png";